<template>
  <div>
    <div class="inner">
      <div class="reviews-grid">
        <div
          v-in-viewport.once
          :key="review.name"
          class="review"
          v-for="review in shuffleArray(reviews).slice(0, $route.name == 'index' ? 8 : 4)"
        >
          <p>{{ review.quote }}</p>
          <p class="name">{{ review.name }}</p>
          <img src="/images/g-stars-alt.png" alt="5 star reviews" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "reviews",
  data() {
    return {
      reviews: [
        {
          quote:
            "Very professional, a pleasure to entrust your tree and garden work to. I would highly recommend Precision Tree Care.",
          name: "Joanne Stubbs"
        },
        {
          quote:
            "Always reliable, friendly and competitively priced they are a pleasure to deal with and I couldn't recommend them highly enough!",
          name: "Jonathan Liversidge"
        },
        {
          quote:
            "We use Precision Tree Care for all our tree work. We highly recommend them as they are reliable, trustworthy and hardworking.",
          name: "Jasmine Marshall"
        },
        {
          quote:
            "Sam & Sarah were efficient, tidy and excellent value for money. I would wholeheartedly recommend their services.",
          name: "David Tyson"
        },
        {
          quote:
            "Sam and his team have always do an excellent job at a reasonable price. We would recommend them to anyone.",
          name: "Tony Fowler"
        },
        {
          quote:
            "Highly recommended and very reasonably priced. Very friendly, offer practical advice and solutions, and leave everything tidy.",
          name: "Joanne Rollitt"
        },
        {
          quote:
            "Sam & Sarah are a fantastic team, they continually produce excellent results at a fair price. I can't recommend them enough.",
          name: "Jason Smart"
        },
        {
          quote:
            "We would highly recommend Precision Tree Care. Their service first class. Professional service with a personal touch.",
          name: "John Kerr"
        }
      ]
    }
  },
  methods: {
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[array[i], array[j]] = [array[j], array[i]]
      }
      return array
    }
  }
}
</script>

<style scoped>
.reviews-title {
  margin-top: 5rem;
  font-size: 4rem;
  display: table;
  width: 100%;
}
.reviews-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin: 5rem 0;
  margin-bottom: 4rem;
  gap: 8rem;
}

.review {
  color: 000;
  position: relative;
  opacity: 0;
  transition: all 1s;
}

.review:nth-child(1) {
  top: 5rem;
}

.review:nth-child(2) {
  top: 6rem;
}

.review:nth-child(3) {
  top: 7rem;
}

.review:nth-child(4) {
  top: 8rem;
}

.review:nth-child(5) {
  top: 5rem;
}

.review:nth-child(6) {
  top: 6rem;
}

.review:nth-child(7) {
  top: 7rem;
}

.review:nth-child(8) {
  top: 8rem;
}

.review.in-viewport {
  top: 0;
  opacity: 1;
}

.review p {
  margin-bottom: 0;
}

.review img {
  width: 12rem;
  margin-top: 2rem;
}

.review .name {
  font-weight: 500;
  font-size: 2rem;
  text-transform: uppercase;
  font-family: "Unica One", "Roboto", Arial;
}

.review p {
  font-size: 1.5rem;
}

.more-reviews {
  text-align: center;
  margin-top: -2rem;
}

@media screen and (max-width: 1300px) {
  .reviews-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 4rem;
  }
}

@media screen and (max-width: 700px) {
  .reviews-grid {
    grid-template-columns: repeat(1, 1fr);
    gap: 3rem;
    margin-bottom: 0rem;
  }
  .review {
    transition: all 0.5s;
  }
}
</style>
